import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ec3b1fcae7cd38b5e47159ad5fc85f81.jpg"
          alt="Technology background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      </div>

      {/* Decorative emerald orb */}
      <div className="absolute top-1/3 right-1/4 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/3 w-64 h-64 rounded-full bg-emerald-400/8 blur-2xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 pt-20">
        <div
          className={`max-w-2xl transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Tag */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/30 rounded-full px-4 py-1.5 mb-8">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse block" />
            <span className="text-emerald-300 text-sm font-medium tracking-wide">iOS App Development</span>
          </div>

          {/* Headline */}
          <h1 className="font-syne font-bold text-6xl lg:text-7xl text-white leading-[1.05] mb-6">
            Crafting
            <br />
            <span className="text-emerald-400">Exceptional</span>
            <br />
            iOS Experiences
          </h1>

          {/* Subtext */}
          <p
            className={`text-white/70 text-xl leading-relaxed max-w-xl transition-all duration-1000 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            FOCUS d.o.o. is a team of experts dedicated to building modern, high-performance applications for the iOS platform — enhancing user experience and fortifying mobile security.
          </p>

          {/* Scroll cue */}
          <div
            className={`mt-16 flex items-center gap-3 transition-all duration-1000 delay-500 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="w-px h-12 bg-gradient-to-b from-transparent to-emerald-400" />
            <span className="text-white/40 text-sm tracking-widest uppercase">Scroll to explore</span>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
